import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import SiteNav from '../marketing/SiteNav';
import SiteFooter from '../marketing/SiteFooter';
import { useApp } from '../../context/AppContext';
import ManagerDashboard from './ManagerDashboard';
import ContractorDashboard from './ContractorDashboard';
import AdminDashboard from './AdminDashboard';

const Dashboard = () => {
  const { user, loading } = useApp();
  const navigate = useNavigate();

  useEffect(() => { if (!loading && !user) navigate('/login'); }, [loading, user, navigate]);

  return (
    <div className="min-h-screen bg-secondary/30">
      <SiteNav />
      <div className="pt-[68px]">
        <div className="max-w-7xl mx-auto px-6 py-10">
          {loading || !user ? (
            <div className="py-32 text-center text-muted-foreground">Loading your workspace…</div>
          ) : (
            <>
              {user.role === 'manager' && <ManagerDashboard />}
              {user.role === 'contractor' && <ContractorDashboard />}
              {user.role === 'admin' && <AdminDashboard />}
            </>
          )}
        </div>
      </div>
      <SiteFooter />
    </div>
  );
};

export default Dashboard;
